module.exports = __webpack_public_path__ + "img/triangle.45c18c44.svg";